module.exports = __webpack_public_path__ + "img/palette-capture-mask.f72c077.svg";